import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RequestingParams } from "../../type";
import { put } from "../../util/APIService";
import { HttpStatus } from "../../enums/httpStatus";

export const updateRequestStatus = createAsyncThunk(
  "update/feedback/request/status",
  async (params: RequestingParams, storeActions) => {
    const url = `api/v1/user/feedback-request-status${params.requestParams}`;
    const response: any = await put(url, params, storeActions);

    if (response.status === HttpStatus.OK) {
      return {
        status: HttpStatus.OK,
        data: await response.text(),
      };
    } else {
      return {
        status: response.status,
        text: await response.text(),
      };
    }
  }
);

const updateRequestStatusSlice = createSlice({
  name: "updateRequestStatus",
  initialState: {
    status: null as number | null,
    loading: false as boolean,
    text: null as string | null,
    data: null as string | null,
  },
  reducers: {
    clearData: (state) => {
      state.status = null;
      state.loading = false;
      state.text = null;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateRequestStatus.fulfilled, (state, action) => {
      state.status = action.payload.status;
      state.loading = false;
      if (action.payload.data !== undefined) {
        state.data = action.payload.data;
        state.text = null;
      } else if (action.payload.text !== undefined) {
        state.data = null;
        state.text = action.payload.text;
      }
    });
    builder.addCase(updateRequestStatus.pending, (state) => {
      state.status = null;
      state.loading = true;
      state.data = null;
      state.text = null;
    });
    builder.addCase(updateRequestStatus.rejected, (state) => {
      state.status = 503;
      state.loading = false;
      state.data = null;
      state.text = null;
    });
  },
});

export const { clearData } = updateRequestStatusSlice.actions;

export default updateRequestStatusSlice;
